import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import Loading from "../../../Student/Reusablecomponents/Loading";

import TinyMCEDitor from "../../../ReusableComponents/tinymceEditor";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  MainSource,
  SubMainSource,
} from "../../../ReusableComponents/QBDropdowns";
import {
  Situation,
  TextFormat,
  TType,
  GradeDD,
  ChapterDD,
  BookDD,
  Booktype,
  BookTypeSubDropDowns,
  UnitNumber,
  UnitName,
} from "../../../ReusableComponents/QBEnglishDropdowns";
import BookSubDropDowns from "../../../ReusableComponents/QBEnglishDropdowns";

import axiosInstance from "../../../ReusableComponents/Axios";
import notify from "../../../ReusableComponents/ToastifyAlerts";

import AP from "../Assests/images/AParameters.svg";
import QBCList from "../../../ReusableComponents/QBCheckList";
const FilterEScenario = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const BookRef = useRef();
  const BookTypeRef = useRef();

   const BTCore = "Core";
  const BTElective = "Elective";

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const updateScenario = useSelector(
    (state) => state.ScenarioDeatils.ScenarioDetails
  );
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );

  const [Load, SetLoad] = useState(false);
  const [NTDeatils, SetNTDeatils] = useState(updateScenario?.mainSourceLovId);
  const [NTBased, SetNTBased] = useState(updateScenario?.sSourceLovId);
  const [TLODetails, SeTLODetails] = useState();
  const [GetEditorValue, SetGetEditorValue] = useState(
    updateScenario?.scenarioName
  );
  const [OtherComents, SetOtherComents] = useState(
    updateScenario?.qsOthersComments
  );

  const [DisplayDD, SetDisplayDD] = useState(updateScenario?.engType || "RC");
  const [SLevelOne, SetSLevelOne] = useState(updateScenario?.situation);
  const [TFormat, SetTFormat] = useState(updateScenario?.text_Format);
  const [TexType, SetTexType] = useState(updateScenario?.text_Type);
  const [Grade, SetGrade] = useState({
    display: "",
    value: updateScenario?.englishGrade,
  });
  const [Chapter, SetChapter] = useState(updateScenario?.unit);
  const [Book, SetBook] = useState(updateScenario?.book);
  const [BType, SetBType] = useState(
    {
    display: updateScenario?.gcTypeName,
    value: updateScenario?.gcTypeId,
  });
  const [BSUB, SetBSUB] = useState({
    MR: updateScenario?.mainReading || "",
    Poem: updateScenario?.mainReadingPoem || "",
    NDL: updateScenario?.nonDetailedLesson || "",
  });
  const [BTSUB, SetBTSUB] = useState({
    SS: updateScenario?.shortstoriesId || "",
    Poem: updateScenario?.mainReadingPoem || "",
    NFI: updateScenario?.nonFictionIntroductionId || "",
    DI: updateScenario?.dramaIntroductionId || "",
    Essay: updateScenario?.essayId || "",
  });
  const GetLOByScenario = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/Scenario/GetLearningOutComesByScenarioId?ScenarioId=${updateScenario?.scenarioID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SeTLODetails(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    GetLOByScenario();
  }, []);
  const AddScenario = async () => {
    if (GetEditorValue?.length > 0) {
      SetLoad((prev) => !prev);
      const ScenarioDetails = {
        scenario: GetEditorValue,
        subjectID: parseInt(items?.subjectId),
        mainSourceLovId: NTDeatils,
        sSourceId: NTBased,
        OtherScenarioComments: OtherComents,
        createdBy: items?.userId,
        situationLevelOne: SLevelOne,
        textFormat: TFormat,
        textType: TexType,
        englishGrade: Grade?.value,
        unit: Chapter,
        book: Book,
        gcType: BType?.value,
        mainReading: BSUB?.MR || 0,
        nonDetailedLesson: BSUB?.NDL || 0,
        mainReadingPoem: BSUB?.Poem || BTSUB?.Poem || 0,
        medium: 0,
        enviornment: 0,
        EngType: DisplayDD,
        shortstories: BTSUB?.SS || 0,
        nonFictionIntroduction: BTSUB?.NFI || 0,
        dramaIntroduction: BTSUB?.DI || 0,
        essays: BTSUB?.Essay || 0,
        addScenarioQuestionChecklist: SCValues,
      };
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + `/Scenario/AddEnglishScenario`,
          ScenarioDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          if (res.data === 2) {
            notify("Scenario added successfully", "success");
            navigate(-1);
          } else {
            notify("Scenario already exists", "error");
          }
        })
        .catch((err) => {
          notify("Scenario not added. Please try again", "error");
        });
      SetLoad((prev) => !prev);
    } else {
      notify("Scenario field is required", "warning");
    }
  };
  const EditScenario = async () => {
    SetLoad((prev) => !prev);
    const ScenarioDetails = {
      scenario: GetEditorValue,
      subjectID: items?.subjectId,
      mainSourceLovId: NTDeatils,
      sSourceId: NTBased,
      otherScenarioComments: OtherComents,
      ModifiedBy: items?.userId,
      ScenarioID: updateScenario?.scenarioID,
      situationLevelOne: SLevelOne,
      textFormat: TFormat,
      textType: TexType,
      englishGrade: Grade?.value,
      unit: Chapter,
      book: Book,
      gcType: BType?.value,
      mainReading: BSUB?.MR || 0,
      nonDetailedLesson: BSUB?.NDL || 0,

      mainReadingPoem: BSUB?.Poem || BTSUB?.Title === "Poem" ? BTSUB.Value : 0,

      medium: 0,
      enviornment: 0,
      EngType: DisplayDD,
      shortstories: BTSUB?.SS || 0,
      nonFictionIntroduction: BTSUB?.NFI || 0,
      dramaIntroduction: BTSUB?.DI || 0,
      essays: BTSUB?.Essay || 0,
      AddScenarioQuestionChecklist: SCValues,
    };
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL + `/Scenario/UpdateEnglishScenario`,
        ScenarioDetails,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        notify("Scenario updated successfully", "success");
        navigate(-1);
      })
      .catch((err) => {
        notify("Scenario not updated - Please try again", "error");
      });

    SetLoad((prev) => !prev);
  };

  const HandleDisplay = (e) => {
    SetDisplayDD(e);
    SetSLevelOne(0);
    SetTFormat(0);
    SetTexType(0);
    SetChapter(0);
    SetBook(0);
    SetBSUB(0);
    SetBTSUB(0);
  };

  const Validation = () => {
    if (DisplayDD !== "G") {
      if (BType?.display !== BTElective) {
        if (BSUB.MR || BSUB.Poem || BSUB.NDL) {
          if (updateScenario) {
            EditScenario();
          } else {
            AddScenario();
          }
        } else {
          notify(
            "Please select any one of the fields - Main Reading, Poem, or Non-Detailed Lesson",
            "warning"
          );
        }
      } else if (
        BTSUB.SS ||
        BTSUB.Poem ||
        BTSUB.NFI ||
        BTSUB.DI ||
        BTSUB.Essay
      ) {
        if (updateScenario) {
          EditScenario();
        } else {
          AddScenario();
        }
      } else {
        notify(
          `Please select any one of the fields - Short Stories,Poem,  ${
            Grade?.value === 51 ? "Essay" : "Non-Fiction,Drama"
          }`,
          "warning"
        );
      }
    } else {
      if (updateScenario) {
        EditScenario();
      } else {
        AddScenario();
      }
    }
  };
  const [UNitNumber, SetUNitNumber] = useState(
    updateScenario?.unitNumber || ""
  );
  const [UNitName, SetUNitName] = useState(updateScenario?.unitName || "");
  // const [SCValues, SetSCValues] = useState();
  // const [SCHeckList, SetSCHeckList] = useState();
  // useEffect(() => {
  //   ScenarioCheckList();
  // }, []);

  // const ScenarioCheckList = async () => {
  //   try {
  //     const res = await axiosInstance.get(
  //       "/Scenario/GetScenarioChecklistQuestions"
  //     );
  //     const Storeids = res.data.map((item, index) => ({
  //       checklistQuestionId: item.checklistQuestionId,
  //       status: parseInt(updateScenario?.status?.[index]) || 0,
  //     }));
  //     SetSCValues(Storeids);
  //     SetSCHeckList(res.data);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // console.log("updateScenario", updateScenario);
  // const StoreCheckList = (id, e) => {
  //   const status = e.target.checked ? 1 : 0;
  //   const Update = SCValues.map((item) =>
  //     item.checklistQuestionId === id ? { ...item, status } : item
  //   );
  //   SetSCValues(Update);
  // };
   const [HitCLV, SetHitCLV] = useState(false);
      const [CValidation, SetCValidation] = useState(false);
        const [SCValues, SetSCValues] = useState();
         useEffect(() => {
            if (CValidation) {
              Validation();
            }
          }, [CValidation]);
  return (
    <>
      <div className="MainHeading">
        {updateScenario ? "Update" : "Add"} Scenario
      </div>
      <div className="Card mt-2">
        <div className="AddOptions">
          <div className="dflex alignitems AUTitles">
            <div className="dflex alignitems">
              {" "}
              <img src={AP} alt="Learning Outcomes" />{" "}
              <div>
                Scenario Source<span className="text-danger">*</span>{" "}
              </div>
            </div>{" "}
            {/*<GoTriangleDown onClick={() => OpenAccordain("LOC")} />*/}
          </div>
          <div className="container-fluid mt-3">
            <Row>
              <Col>
                {" "}
                <MainSource
                  className="NCLDropdown w-100"
                  StoreMSource={SetNTDeatils}
                  SOption={NTDeatils}
                  onChange={(e) => SetNTDeatils(e)}
                  LID={SelectLanguage}
                />{" "}
              </Col>
              <Col>
                {" "}
                <SubMainSource
                  className="NCLDropdown w-100"
                  StoreSMSource={SetNTBased}
                  SOption={NTBased}
                  PId={NTDeatils}
                  onChange={(e) => SetNTBased(e)}
                  LID={SelectLanguage}
                />
                {(NTBased === "3574" || NTBased === "3578") && (
                  <input
                    type="text"
                    className=" Search mt-2 p-1 w-100"
                    onChange={(e) => SetOtherComents(e.target.value)}
                    placeholder="Enter Comments"
                  />
                )}
              </Col>
            </Row>
          </div>
        </div>
        <div className="dflex  mt-3" style={{ gap: "15px" }}>
          {["RC", "G"].map((Item) => (
            <div key={Item} className="dflex alignitems" style={{ gap: "5px" }}>
              <input
                type="Radio"
                value={Item}
                name="NSBased"
                disabled
                checked={DisplayDD === Item}
                onChange={() => HandleDisplay(Item)}
              />{" "}
              <b>{Item === "G" ? "Grammar" : "Reading Comprehension"}</b>
            </div>
          ))}
        </div>

        {DisplayDD !== "G" && (
          <div className="AddOptions">
            <div className="dflex alignitems AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={AP} alt="Learning Outcomes" />{" "}
                <div>
                  Assessment Parameters<span className="text-danger">*</span>{" "}
                </div>
              </div>{" "}
              {/*<GoTriangleDown onClick={() => OpenAccordain("LOC")} />*/}
            </div>

            <div className="container-fluid">
              <Row>
                <Col>
                  {" "}
                  <Situation
                    className="NCLDropdown w-100"
                    StoreMSource={SetSLevelOne}
                    SOption={SLevelOne}
                    onChange={(e) => SetSLevelOne(e)}
                    labelname={
                      <div className="DropdownHeader">
                        Situation<span>*</span>
                      </div>
                    }
                  />
                </Col>
                <Col>
                  {" "}
                  <TextFormat
                    className="NCLDropdown w-100"
                    StoreMSource={SetTFormat}
                    SOption={TFormat}
                    onChange={(e) => SetTFormat(e)}
                    labelname={
                      <div className="DropdownHeader">
                        Text Format<span>*</span>
                      </div>
                    }
                  />
                </Col>
                <Col>
                  {" "}
                  <TType
                    className="NCLDropdown w-100"
                    StoreMSource={SetTexType}
                    SOption={TexType}
                    onChange={(e) => SetTexType(e)}
                    labelname={
                      <div className="DropdownHeader">
                        Text Type<span>*</span>
                      </div>
                    }
                  />
                </Col>
              </Row>
            </div>
          </div>
        )}

        <div className="AddOptions">
          <div className="dflex alignitems AUTitles">
            <div className="dflex alignitems">
              {" "}
              <img src={AP} alt="Learning Outcomes" />{" "}
              <div>
                Grade and Curriculum Mapping
                <span className="text-danger">*</span>{" "}
              </div>
            </div>{" "}
            {/*<GoTriangleDown onClick={() => OpenAccordain("LOC")} />*/}
          </div>
          <div className="container-fluid">
            <Row>
              <Col>
                {" "}
                <GradeDD
                  Change={true}
                  className="NCLDropdown w-100"
                  StoreMSource={SetGrade}
                  SOption={Grade?.value}
                  onChange={(e) => {}}
                  // onChange={(e) => SetGrade(parseInt(e))}
                  labelname={
                    <div className="DropdownHeader">
                      Grade<span>*</span>
                    </div>
                  }
                />
              </Col>

              <Col>
                <div style={DisplayDD === "G" ? {display:"none"} :{}}>
                <Booktype
                  className={`w-100 ${
                    Grade?.value === 52 || Grade?.value === 51
                      ? "NCLDropdown"
                      : "DisabledNCLDropdown"
                  }`}
                  StoreMSource={SetBType}
                  SOption={BType?.value}
                  Grade={Grade?.value}
                  onChange={(e) => SetBType(e)}
                  disable={Grade?.value !== 52 && Grade?.value !== 51}
                  labelname={
                    <div className="DropdownHeader">
                      Book Type<span>*</span>
                    </div>
                  }
                /></div>
              </Col>
            </Row>

            {(Grade?.display === "1" ||
              Grade?.display === "2" ||
              Grade?.display === "Pre-primary") &&
              DisplayDD !== "G" && (
                <Row>
                  <Col>
                    <UnitNumber
                      className="NCLDropdown w-100"
                      Displayname="Select Unit Number"
                      PID={Grade?.value}
                      LID={SelectLanguage}
                      StoreMSource={SetUNitNumber}
                      SOption={UNitNumber}
                      onChange={(e) => SetUNitNumber(e)}
                      labelname={
                        <div className="DropdownHeader">
                          {" "}
                          Unit Number<span>*</span>{" "}
                        </div>
                      }
                    />
                    {/* {AQErrors?.UNitNumber && (<span className="error-message">{AQErrors?.UNitNumber}</span>)} */}
                  </Col>
                  <Col>
                    <UnitName
                      className="NCLDropdown w-100"
                      Displayname="Select Unit Name"
                      PID={UNitNumber}
                      LID={SelectLanguage}
                      StoreMSource={SetUNitName}
                      SOption={UNitName}
                      onChange={(e) => SetUNitName(e)}
                      labelname={
                        <div className="DropdownHeader">
                          {" "}
                          Unit Name<span>*</span>{" "}
                        </div>
                      }
                    />
                    {/* {AQErrors?.UNitName && (<span className="error-message">{AQErrors?.UNitName}</span>)} */}
                  </Col>
                </Row>
              )}
            <Row>
              {DisplayDD !== "G" ? (
                <>
                  <Col>
                    {" "}
                    <ChapterDD
                      className="NCLDropdown w-100"
                      StoreMSource={SetChapter}
                      SOption={Chapter}
                      onChange={(e) => SetChapter(e)}
                      labelname={
                        <div className="DropdownHeader">
                          CBSE / SCERT Chapter No<span>*</span>
                        </div>
                      }
                    />
                  </Col>
                  <Col>
                    {" "}
                    <BookDD
                      className="NCLDropdown w-100"
                      Grade={Grade?.value}
                      Chapter={Chapter}
                      GCtype={BType?.value}
                      StoreMSource={SetBook}
                      SOption={Book}
                      onChange={(e) => SetBook(e)}
                      labelname={
                        <div className="DropdownHeader">
                          Book<span>*</span>
                        </div>
                      }
                    />
                  </Col>
                </>
              ) : (
                <>
                  <Col></Col>
                  <Col></Col>
                </>
              )}{" "}
            </Row>

            {DisplayDD !== "G" && (
              <>
                {BType?.display !== BTElective ? (
                  <BookSubDropDowns
                    className="NCLDropdown w-100"
                    Grade={Grade?.value}
                    Chapter={Chapter}
                    Book={Book}
                    StoreMSource={SetBSUB}
                    SOption={BSUB}
                    ref={BookRef}
                  />
                ) : (
                  <BookTypeSubDropDowns
                    className="NCLDropdown w-100"
                    Grade={Grade?.value}
                    Chapter={Chapter}
                    Book={Book}
                    GCtype={BType?.value}
                    StoreMSource={SetBTSUB}
                    SOption={BTSUB}
                    ref={BookTypeRef}
                  />
                )}
              </>
            )}
          </div>
        </div>
        <div className="m-2">
          Scenario <span className="text-danger">*</span>
        </div>

        <div className="container-fluid">
          <Row>
            <Col>
              <TinyMCEDitor
                onChange={(e) => SetGetEditorValue(e)}
                PostValue={GetEditorValue}
              />
            </Col>
            <Col>
              <div className="NCLDataTable">
                <table className="Data-Table">
                  <thead>
                    <tr>
                      <th colSpan={4}>Learning Outcome wise Questions</th>
                    </tr>
                    <tr>
                      <th>S.No</th>
                      <th>LO Name</th>
                      <th>Grade</th>
                      <th>No. of Questions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {TLODetails?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.learningOutcomes}</td>
                        <td>{item.gradeName}</td>
                        <td>{item.noOfQuestions}</td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={4}>
                        * Learning outcome mapped to parent scenario
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </div>

        {/* <div className="mt-4">
          {" "}
          <div className="dflex flexd-column">
            {" "}
            <b>Checklist for Scenario Submission</b>
            <span> Language, Grammar, and Formatting checks</span>
          </div>
          <ol>
            {SCHeckList &&
              SCHeckList?.map((item, index) => (
                <li className="dflex gap-2 alignitems">
                  {/* to be commented for production *
                  <input
                    type="checkbox"
                    checked={!!SCValues?.[index]?.status}
                    onChange={(e) =>
                      StoreCheckList(item.checklistQuestionId, e)
                    }
                  />
                  {item.checklistQuestion}
                </li>
              ))}
          </ol>
        </div> */}
          <QBCList Heading="Scenario" HValidation={HitCLV} RStoreHValidation={SetHitCLV} VSuccess={SetCValidation}
          GetValues={SetSCValues} Existinvalues={updateScenario?.status} ExistingId={updateScenario?.checklistQuestionId} LanguageId={SelectLanguage}/>
        <div className="ScenarioAU dflex alignitems">
          <button className="Buttons bg-danger" onClick={() => navigate(-1)}>
            Cancel
          </button>
          <button className="Buttons bg-success" onClick={()=>{Validation(); SetHitCLV(true);}}>
            {updateScenario ? (
              <>
                Update{" "}
                <span style={{ fontSize: "8px" }}>
                  (Please go Through The Below Checklist Before Updating The
                  Scenario)
                </span>{" "}
              </>
            ) : (
              "Save"
            )}{" "}
          </button>
        </div>
      </div>

      {Load && <Loading />}
    </>
  );
};
export default FilterEScenario;
